import { authMiddleware } from '@/router/guards/auth'
import { validateAppRoute } from '@/router/guards/bootstrap'

export const registerRouterGuards = (router) => {
  router.beforeEach(authMiddleware)
  router.beforeResolve(validateAppRoute)
}
